// extracted by mini-css-extract-plugin
export default {"EditionDocuments":"EditionDocuments_EditionDocuments__Lhhrx","ListeDocuments":"EditionDocuments_ListeDocuments__9WJH5"};